import { useUserIdentityState } from '@provider/user-identity';
import { useComponentEntry } from '@utils/component-framework';

function useUserOwnsEntry(entryKey) {
  const entryId = useComponentEntry(entryKey, {
    select: data => data?.envelope.userID
  });
  const user = useUserIdentityState(state => state.user);
  const userOwnsEntry = user?.id === entryId.data;
  return userOwnsEntry;
}

export { useUserOwnsEntry };
//# sourceMappingURL=hook.user-owns-entry.js.map
